import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr } from "@/lib/api";
import { PageIntro } from "@/components/PageIntro";

export default function Safaris() {
  const [safaris, setSafaris] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/safaris").then((r) => setSafaris(r.data.filter((s) => s.booking_mode !== "on_request"))); }, []);

  const cats = ["all", ...Array.from(new Set(safaris.map((s) => s.category)))];
  const filtered = cat === "all" ? safaris : safaris.filter((s) => s.category === cat);

  return (
    <div className="jt-container py-16">
      <PageIntro page="safaris"/>
      <div className="flex flex-wrap gap-2 mb-10">
        {cats.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c}`}
            className={`px-4 py-2 rounded-full text-sm border ${cat === c ? "bg-[#1E3A2B] text-white border-[#1E3A2B]" : "bg-white border-[#E2DACF] text-[#1C2421]"}`}>
            {c}
          </button>
        ))}
      </div>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {filtered.map((s) => (
          <Link key={s.id} to={`/safaris/${s.slug}`} data-testid={`safari-card-${s.slug}`}
            className="group bg-white ring-1 ring-black/5 rounded-2xl overflow-hidden">
            <div className="h-56 overflow-hidden">
              <img src={s.image_url} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transform duration-500"/>
            </div>
            <div className="p-5">
              <h3 className="font-serif text-xl text-[#1C2421]">{s.name}</h3>
              <p className="text-sm text-[#5C6B63] mt-1 mb-3 line-clamp-2">{s.short_description}</p>
              <div className="flex items-center justify-between">
                <span className="font-mono text-sm text-[#1E3A2B]">from {inr(s.base_price)}</span>
                <span className="text-[#C86D51] text-sm">View →</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
